import { CapacityProviderType, SearchFilter } from '@rygen/rygen-ui/model';

import { Carrier } from './Carrier';

export class CarrierSearchFilter extends SearchFilter<Carrier> {
  query = '';

  type?: CapacityProviderType;

  constructor(opts?: Partial<CarrierSearchFilter>) {
    super(opts);

    this.sortField = opts?.sortField ?? 'name';

    if (opts?.query != null) {
      this.query = opts.query;
    }

    if (opts?.type != null) {
      this.type = opts.type;
    }
  }
}
